import React from "react";
import { useParams, useHistory} from "react-router-dom";
import {
   Loader
} from "@egovernments/digit-ui-react-components";
import Form12SummaryView from "./Form12ViewAction";


function ApplicationView12 ({id,formType}) {
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const { data = {}, isLoading } = Digit.Hooks.obps.useBPADetailsPage(stateId, { applicationNo: id, isEmployee });
  const {
    applicationData,
    edcrDetails,
    collectionBillDetails
  } = data;
  if (!isLoading && data) {
      console.log("dfygbhusw",data ,id,formType);
    // data.paymentDetails = collectionBillRes?.[0]?.paymentDetails?.[0];
  }

if(isLoading){
    return <Loader/>
}
 
  return (
    <React.Fragment>
        {!isLoading && data &&(
      <Form12SummaryView
       formData={applicationData}
       edcrDetails={edcrDetails}
        collectionBillDetails={collectionBillDetails}
      />
      )}
    </React.Fragment>
  );
}

export default ApplicationView12;
